"use client";
import Link from "next/link";
import { useEffect, useState } from "react";
export default function Footer1() {
  const [isAccordion1, setIsAccordion1] = useState(0);
  const [isAccordion2, setIsAccordion2] = useState(0);
  const [isAccordion3, setIsAccordion3] = useState(0);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    handleResize(); // Run on initial load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleAccordion1 = (key) => {
    if (!isDesktop) {
      setIsAccordion1((prev) => (prev === key ? null : key));
    }
  };
  const handleAccordion2 = (key) => {
    if (!isDesktop) {
      setIsAccordion2((prev) => (prev === key ? null : key));
    }
  };
  const handleAccordion3 = (key) => {
    if (!isDesktop) {
      setIsAccordion3((prev) => (prev === key ? null : key));
    }
  };

  const getDisplayStyle1 = (key) => {
    return isDesktop ? "block" : isAccordion1 === key ? "block" : "none";
  };
  const getDisplayStyle2 = (key) => {
    return isDesktop ? "block" : isAccordion2 === key ? "block" : "none";
  };
  const getDisplayStyle3 = (key) => {
    return isDesktop ? "block" : isAccordion3 === key ? "block" : "none";
  };
  return (
    <>
      <footer id="footer" className="style-2">
        <div className="tf-container">
          <div className="row">
            <div className="col-12">
              <div className="footer-top">
                <div className="footer-logo">
                  <Link href="/">
                    <img
                      id="logo_footer"
                      src="/images/logo/pro-ear-clinic-white.svg"
                      data-retina="./images/logo/pro-ear-clinic-white.svg"
                      alt="healingy"
                    />
                  </Link>
                </div>
                <div className="wrap-social">
                  <div className="text-3 fw-6 text-white">Follow Us On:</div>
                  <ul className="tf-social">
                    <li>
                      <Link
                        href="https://www.instagram.com/proearclinic/"
                        target="_blank"
                        aria-label="Visit ProEar Clinic Instagram"
                      >
                        <svg
                          width={20}
                          height={20}
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_11089_891)">
                            <path
                              d="M10 13.125C11.7259 13.125 13.125 11.7259 13.125 10C13.125 8.27411 11.7259 6.875 10 6.875C8.27411 6.875 6.875 8.27411 6.875 10C6.875 11.7259 8.27411 13.125 10 13.125Z"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M13.75 2.5H6.25C4.17893 2.5 2.5 4.17893 2.5 6.25V13.75C2.5 15.8211 4.17893 17.5 6.25 17.5H13.75C15.8211 17.5 17.5 15.8211 17.5 13.75V6.25C17.5 4.17893 15.8211 2.5 13.75 2.5Z"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M14.0625 6.71875C14.494 6.71875 14.8438 6.36897 14.8438 5.9375C14.8438 5.50603 14.494 5.15625 14.0625 5.15625C13.631 5.15625 13.2812 5.50603 13.2812 5.9375C13.2812 6.36897 13.631 6.71875 14.0625 6.71875Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_11089_891">
                              <rect width={20} height={20} fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </Link>
                    </li>
                    <li>
                      <Link
                        href="https://www.facebook.com/proearclinic"
                        target="_blank"
                        aria-label="Visit ProEar Clinic Facebook"
                      >
                        <svg
                          width={20}
                          height={20}
                          viewBox="0 0 24 24"
                          fill="white"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M22.675 0h-21.35C.595 0 0 .592 0 1.326v21.348C0 23.408.595 24 1.325 24h11.495v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.918.001c-1.504 0-1.797.715-1.797 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116C23.406 24 24 23.408 24 22.674V1.326C24 .592 23.406 0 22.675 0" />
                        </svg>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="footer-main">
                <div className="footer-menu-list footer-col-block">
                  <div className="title title-desktop text-3xl leading-tight font-semibold mb-24">
                    ProEar Clinic
                  </div>
                  <div
                    className="title title-mobile text-3xl leading-tight font-semibold"
                    onClick={() => handleAccordion1(1)}
                  >
                    {" "}
                    ProEar Clinic
                  </div>
                  <ul
                    className="tf-collapse-content"
                    style={{ display: getDisplayStyle1(1) }}
                  >
                    <li>
                      <Link href="/about-us">About Us</Link>
                    </li>
                    <li>
                      <Link href="/blog">Blog</Link>
                    </li>
                    <li>
                      <Link href="/earwax-removal/microsuction#faq">
                        FAQ&apos;s
                      </Link>
                    </li>
                    <li>
                      <Link href="/contact-us">Contact Us</Link>
                    </li>
                  </ul>
                </div>
                <div className="footer-menu-list footer-col-block">
                  <div className="title title-desktop text-3xl leading-tight font-semibold mb-24">
                    Our Services
                  </div>
                  <div
                    className="title title-mobile text-3xl leading-tight font-semibold"
                    onClick={() => handleAccordion1(2)}
                  >
                    Our Services
                  </div>

                  <ul
                    className="tf-collapse-content"
                    style={{ display: getDisplayStyle1(2) }}
                  >
                    <li>
                      <Link href="/earwax-removal/microsuction">
                        Microsuction
                      </Link>
                    </li>
                    <li>
                      <Link href="/earwax-removal/water-irrigation">
                        Water Irrigation
                      </Link>
                    </li>
                    <li>
                      <Link href="/earwax-removal/pre-hearing-aid-wax-removal">
                        Pre-Hearing Aid Wax Removal
                      </Link>
                    </li>
                    <li>
                      <Link href="/earwax-removal/clinic-earwax-removal-bristol">
                        Clinic Earwax Removal Bristol
                      </Link>
                    </li>
                    <li>
                      <Link href="/earwax-removal/home-visit-earwax-removal-bristol">
                        Home Visit Earwax Removal Bristol
                      </Link>
                    </li>
                    <li>
                      <Link href="/earwax-removal/ear-health-assessment">
                        Ear Health Assessment Bristol
                      </Link>
                    </li>
                    <li>
                      <Link href="/earwax-removal/childrens-earwax-removal-bristol">
                        Children&apos;s Earwax Removal Bristol
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="wrap-form footer-col-block">
                  <div className="title title-desktop text-3xl leading-tight font-semibold">
                    Subscribe Newsletter
                  </div>
                  <div
                    className="title title-mobile text-3xl leading-tight font-semibold"
                    onClick={() => handleAccordion1(4)}
                  >
                    Subscribe Newsletter
                  </div>
                  <div
                    className="tf-collapse-content"
                    style={{ display: getDisplayStyle1(4) }}
                  >
                    <form className="form-send-email">
                      <fieldset>
                        <input
                          type="email"
                          placeholder="Your email address"
                          name="text"
                          aria-required="true"
                          required
                        />
                      </fieldset>
                      <div className="button-submit">
                        <button type="submit">
                          <i className="icon-PaperPlaneTilt" />
                        </button>
                      </div>
                    </form>
                    <p>
                      Please sign up to follow the latest news and events from
                      us, we promise not to spam your inbox.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-bottom">
              <p>
                Copyright {new Date().getFullYear()} Pro Ear Clinic. All rights
                reserved
              </p>
              <ul className="content-right">
                <li>
                  <Link href="/#">Terms Of Services</Link>
                </li>
                <li>
                  <Link href="/privacy-policy"> Privacy Policy</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
